module.exports = __webpack_public_path__ + "img/coupon-applied.f13f7c49.svg";